<p-table #table [value]="loadedEntries" [lazy]="scIsLazy" (onLazyLoad)="loadRecords($event)" [paginator]="true"
  [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [tableStyle]="{ 'min-width': '75rem' }" [selection]="selectedEntries" (selectionChange)="onSelectionChange($event)"
  (onEditComplete)="onEditComplete($event)" (selectAllChange)="onSelectAllChange($event)" [editMode]="'cell'"
  [rows]="scPageSize" [loading]="loading" [globalFilterFields]="globalFilterFields" [className]="scClass"
  [scrollable]="true" scrollHeight="calc(100vh - 200px)" [reorderableColumns]="scReorderColumns" [columns]="gridColumns"
  [ngClass]="{'toggleable-columns-grid': scToggleColumns}">

   @if (scToggleColumns) {
    <ng-template pTemplate="caption">
      <p-multiSelect display="chip" [maxSelectedLabels]="10" [options]="columnsOptions" [(ngModel)]="selectedColumns"
        (onChange)="onSelectedColumnsChanged()" optionLabel="title" selectedItemsLabel="{0} columns selected"
        placeholder="Choose Columns" />
    </ng-template>
  }

  <ng-template pTemplate="header">
    <!-- column header row -->
    <tr>
      @if(scSelectionEnabled){
      <th style="width: 4rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      }
      @for (column of gridColumns; track column.field || $index) {
        @if(scReorderColumns) {
        <th [pSortableColumn]="(column.type !== 8 && column.type !== 9 && column.type !== 10 && !column.isNotSortable) ? column.field : ''"
          pReorderableColumn [pReorderableColumnDisabled]="!column.isReorderable">
          {{ column.title }}
          @if (column.type !== 8 && column.type !== 9 && column.type !== 10 && !column.isNotSortable) {
          <p-sortIcon [field]="column.field"></p-sortIcon>
          }
        </th>
        } @else {
        <th [pSortableColumn]="(column.type !== 8 && column.type !== 9 && column.type !== 10 && !column.isNotSortable) ? column.field : ''">
          {{ column.title }}
          @if (column.type !== 8 && column.type !== 9 && column.type !== 10 && !column.isNotSortable) {
          <p-sortIcon [field]="column.field"></p-sortIcon>
          }
        </th>
        }
      }
    </tr>

    <!-- select-all/filters row -->
    <tr>
      @if(scSelectionEnabled) {
        <th style="width: 4rem" ></th>
      }
      @for (column of gridColumns; track column.field || $index) {
        <th>
          @if(scIsSearchable && column.type !== 8 && column.type !== 4 && column.type !== 9 && column.type !== 10){
            <p-columnFilter [type]="'text'" [field]="column.field"></p-columnFilter>
          }
        </th>
      }
    </tr>
  </ng-template>

  <!-- data -->
  <ng-template pTemplate="body" let-record let-ri="rowIndex">
    <tr>
      <!-- selection checkbox -->
      @if(scSelectionEnabled) {
        <td>
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
        </td>
      }

      <!-- data columns -->
      @for (column of gridColumns; track column.field || $index) {
        <td [pEditableColumn]="record[column.field]" [pEditableColumnRowIndex]="ri" [pEditableColumnField]="column.field">
          <!-- Check if action (in action column) is disabled for the current column and record -->
          @if ({ actionDisabled: isCellActionDisabled(column, record) }; as actionState) {
            @switch (typesMappings[column.type]) {
              <!-- text -->
              @case ('text') {
                @if (column.isEditable) {
                  <p-cellEditor>
                    <!-- edit -->
                    <ng-template pTemplate="input">
                      <text-editor [record]="record" [column]="column"></text-editor>
                    </ng-template>
                    <!-- display -->
                    <ng-template pTemplate="output">
                      <text-viewer [record]="record" [column]="column"></text-viewer>
                    </ng-template>
                  </p-cellEditor>
                }
                @if (column.actionSettings) {
                  <a href="javascript: void(0);" (click)="onActionClick(column, record)" [title]="column.hover">
                    @if (!column.isEditable) {
                      <text-viewer [record]="record" [column]="column"></text-viewer>
                    }
                  </a>
                } @else {
                  @if (!column.isEditable) {
                    <text-viewer [record]="record" [column]="column"></text-viewer>
                  }
                }
              }

              <!-- number -->
              @case ('numeric') {
                @if (column.isEditable) {
                  <p-cellEditor>
                    <!-- edit -->
                    <ng-template pTemplate="input">
                      <number-editor [record]="record" [column]="column"></number-editor>
                    </ng-template>
                    <!-- display -->
                    <ng-template pTemplate="output">
                      <number-viewer [record]="record" [column]="column"></number-viewer>
                    </ng-template>
                  </p-cellEditor>
                }

                @if (column.actionSettings && !actionState.actionDisabled) {
                  <a href="javascript: void(0);" (click)="onActionClick(column, record)" [title]="column.hover">
                    @if (!column.isEditable) {
                      <number-viewer [record]="record" [column]="column"></number-viewer>
                    }
                  </a>
                }
                @if (!column.isEditable && (actionState.actionDisabled || !column.actionSettings)) {
                  <number-viewer [record]="record" [column]="column"></number-viewer>
                }
              }

              <!-- multi -->
              @case ('multi') {
                @if (column.isEditable) {
                  <p-cellEditor>
                    <!-- edit -->
                    <ng-template pTemplate="input">
                      <multi-select-editor [record]="record" [column]="column"></multi-select-editor>
                    </ng-template>
                    <!-- display -->
                    <ng-template pTemplate="output">
                      @if (column.multiSelectSettings?.data) {
                        <multi-select-viewer [record]="record" [column]="column"></multi-select-viewer>
                      }
                    </ng-template>
                  </p-cellEditor>
                }
                @if (!column.isEditable) {
                  <div>
                    @if (column.multiSelectSettings?.data) {
                      <multi-select-viewer [record]="record" [column]="column"></multi-select-viewer>
                    }
                  </div>
                }
              }

              <!-- combo -->
              @case ('combo') {
                @if (column.isEditable) {
                  <p-cellEditor>
                    <!-- edit -->
                    <ng-template pTemplate="input">
                      <dd-editor [record]="record" [column]="column"></dd-editor>
                    </ng-template>
                    <!-- display -->
                    <ng-template pTemplate="output">
                      @if (column.comboSettings?.data) {
                        <combo-viewer [record]="record" [column]="column"></combo-viewer>
                      }
                    </ng-template>
                  </p-cellEditor>
                }
                @if (!column.isEditable) {
                  <div>
                    @if (column.comboSettings?.data) {
                      <combo-viewer [record]="record" [column]="column"></combo-viewer>
                    }
                  </div>
                }
              }

              <!-- boolean -->
              @case ('boolean') {
                @if (column.isEditable) {
                  <p-cellEditor>
                    <!-- edit -->
                    <ng-template pTemplate="input">
                      <boolean-editor [record]="record" [column]="column"></boolean-editor>
                    </ng-template>
                    <!-- display -->
                    <ng-template pTemplate="output">
                      <boolean-viewer [record]="record" [column]="column"></boolean-viewer>
                    </ng-template>
                  </p-cellEditor>
                }

                @if (!column.isEditable) {
                  <div>
                    <boolean-viewer [record]="record" [column]="column"></boolean-viewer>
                  </div>
                }
              }

              <!-- date -->
              @case ('date') {
                @if (column.isEditable) {
                  <p-cellEditor>
                    <!-- edit -->
                    <ng-template pTemplate="input">
                      <date-editor [record]="record" [column]="column"></date-editor>
                    </ng-template>
                    <!-- display -->
                    <ng-template pTemplate="output">
                      <date-viewer [record]="record" [column]="column"></date-viewer>
                    </ng-template>
                  </p-cellEditor>
                }

                @if (!column.isEditable) {
                  <div>
                    <date-viewer [record]="record" [column]="column"></date-viewer>
                  </div>
                }
              }

              <!-- icon -->
              @case ('icon') {
                <div class="icon-column {{ !!column.actionSettings && !actionState.actionDisabled ? 'clickable' : '' }} {{ actionState.actionDisabled ? 'cell-action-disabled' : '' }}"
                  (click)="onActionClick(column, record)" [attr.aria-disabled]="actionState.actionDisabled">
                  @if (record[column.field]) {
                    <img src="{{record[column.field]}}" title="{{column.hover}}">
                  }
                </div>
              }

              <!-- action -->
              <!-- display only -- no edit -->
              @case ('action') {
                <button class="{{ column.cssClass ?? '' }}" (click)="onActionClick(column, record)"
                  [disabled]="actionState.actionDisabled">
                  {{ column.actionSettings?.name != '' ? column.actionSettings?.name : record[column.field] }}
                </button>
              }

              <!-- link -->
              @case ('link') {
                <a class="{{ column.cssClass ?? '' }} {{ actionState.actionDisabled ? 'cell-action-disabled' : '' }}"
                  [routerLink]="actionState.actionDisabled ? null : column.linkSettings?.routerLink(record)"
                  [attr.aria-disabled]="actionState.actionDisabled" [attr.tabindex]="actionState.actionDisabled ? -1 : null"
                  (click)="actionState.actionDisabled && $event.preventDefault()">
                  {{ column.linkSettings?.name != '' ? column.linkSettings?.name : record[column.field] }}
                </a>
              }
            }
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>
